import { Component, OnInit } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { ConsultaService } from 'src/app/services/consulta.service';
import { Usuarios } from 'src/app/models/usuarios';
import { Router } from '@angular/router';
import { Md5 } from 'ts-md5/dist/md5';
import { AlertController } from '@ionic/angular';
import { propietario } from '../../services/config';


@Component({
  selector: 'app-registrarse',
  templateUrl: './registrarse.page.html',
  styleUrls: ['./registrarse.page.scss'],
  providers: [Camera]
})
export class RegistrarsePage implements OnInit {

  public step2: boolean;
  public marcas: Array<string>;
  public usuario: Usuarios;
  public confirmarEmail: string;
  public confirmarPassword: string;

  public bntSiguiente: boolean;
  public CTLazo: string;

  constructor(
    public _camera: Camera,
    private _router: Router,
    private _consulta: ConsultaService,
    public alertController: AlertController
  ) {
    this.step2 = false;   //CAMBIAR!!!
    this.usuario = new Usuarios();
    this.usuario.legalCondiciones = false;
  }

  ngOnInit() {

  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'Faltan campos por rellenar.',
      buttons: ['OK']
    });
    await alert.present();
  }

  async alertTerminosYCondiciones() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'Para poder continuar tienes que aceptar los Términos y Condiciones.',
      buttons: ['OK']
    });
    await alert.present();
  }
  

  async alertEmail() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'Los emails no coinciden.',
      buttons: ['OK']
    });
    await alert.present();
  }

  async alertPass() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'Las contraseñas no coinciden.',
      buttons: ['OK']
    });
    await alert.present();
  }

  async alertEmailNoValido() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'El email no es válido.',
      buttons: ['OK']
    });
    await alert.present();
  }

  async alertUsuarioNoValido() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'El DNI o el email no son válidos.',
      buttons: ['OK']
    });
    await alert.present();
  }

  async alertExitoRegistro() {
    const alert = await this.alertController.create({
      header: '¡Genial!',
      message: 'Te has registrado con éxito. Ya puedes usar MyEntry.',
      buttons: ['OK']
    });
    await alert.present();
  }

  async alertErrorRegistro() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'Algo ha ido mal... Inténtalo más tarde.',
      buttons: ['OK']
    });
    await alert.present();
  }
  
  async alertErrorNombre() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'Escribe un nombre, por favor.',
      buttons: ['OK']
    });
    await alert.present();
  }

  async alertErrorApellidos() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'Por favor, escribe tus apellidos.',
      buttons: ['OK']
    });
    await alert.present();
  }

  /*async alertErrorNIF() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'El DNI no es válido.',
      buttons: ['OK']
    });
    await alert.present();
  }*/

  /*async alertErrorMovil() {
    const alert = await this.alertController.create({
      header: '¡Atención!',
      message: 'Introduce un número de movil válido.',
      buttons: ['OK']
    });
    await alert.present();
  }*/

  //VALIDA NIF

  validateDNI(dni) {
    let numero, le, letra;
    let expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;

    dni = dni.toUpperCase();

    if (expresion_regular_dni.test(dni) === true) {
      numero = dni.substr(0, dni.length - 1);
      numero = numero.replace('X', 0);
      numero = numero.replace('Y', 1);
      numero = numero.replace('Z', 2);
      le = dni.substr(dni.length - 1, 1);
      numero = numero % 23;
      letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letra = letra.substring(numero, numero + 1);
      if (letra != le) {
        //alert('Dni erroneo, la letra del NIF no se corresponde');
        return false;
      } else {
        //alert('Dni correcto');
        return true;
      }
    } else {
      //alert('Dni erroneo, formato no válido');
      return false;
    }
  }

  changeStep(value) {
    if (this.usuario.Nombre == undefined || this.usuario.Nombre == "") {
      this.alertErrorNombre();
    } else if (this.usuario.Apellidos == undefined || this.usuario.Apellidos == "") {
      this.alertErrorApellidos();
    } else if (this.usuario.Email.localeCompare(this.usuario.ConfEmail) != 0) {
      this.alertEmail();
    } else if (this.usuario.Email.includes("@") == false || this.usuario.Email.includes(".") == false) {
      this.alertEmailNoValido();
    } else if (this.step2 == true) {
      this.step2 = value;
    } else if (this.usuario.Nombre && this.usuario.Apellidos && this.usuario.Email) {
      this.step2 = value;
    } else {
      this.presentAlert();
    };
  }

  postUser() {
    let myCode = Md5.hashStr(this.usuario.Password);

    let x = '{"clave" : "REGISTRO", "name" : "' + this.usuario.Nombre +
        '", "surname" : "' + this.usuario.Apellidos +
        '", "email" : "' + this.usuario.Email +
        '", "telefono" : "' + this.usuario.Movil +
        '", "nif" : "' + this.usuario.NIF +
        '", "password" : "' + myCode +
        '", "id" : "' + propietario +
        '" }';
    
    this._consulta.registro(x).subscribe(
      (data) => {
        if (data['acceso'] == "No" && data['id'] == null) {
          this.alertUsuarioNoValido();
        } else {
          this._consulta.usuario.Id = data['id'];
          this.alertExitoRegistro();
          this._router.navigate(['/principal']);
        };
      },
      error => {
        error;
        this.alertErrorRegistro();
      }
    );
  }

  submitBasic() {
    if (this.usuario.Password) {
      if (this.usuario.legalCondiciones == false) {
        this.alertTerminosYCondiciones();
      } else if (this.usuario.Password.localeCompare(this.usuario.ConfPass) != 0) {
        this.alertPass();
      } else {
        this.postUser();
      };
    } else {
      this.presentAlert();
    };
  }

  validateCheckboxLC(value) {
    this.usuario.legalCondiciones = value;
  }

  terminos(value) {
    this._consulta.legal = value;
    this._router.navigate(['/aviso-legal']);
  }

}
